import { render, staticRenderFns } from "./ArticleWhitePanel.vue?vue&type=template&id=41bca8e7&scoped=true&"
import script from "./ArticleWhitePanel.vue?vue&type=script&lang=js&"
export * from "./ArticleWhitePanel.vue?vue&type=script&lang=js&"
import style0 from "./ArticleWhitePanel.vue?vue&type=style&index=0&id=41bca8e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bca8e7",
  null
  
)

export default component.exports